export default __webpack_public_path__ + "static/bar-bg-a310473804ce229570ee738e16a934aa.svg";